import { createAction, props } from '@ngrx/store';

export const AccordionOpen = createAction(
  '[GA Product Tips] Accordion opened',
  props<{ title: string }>()
);

export const TipPageLoad = createAction('[GA Product Tips] Page load');

export const BrowseNewProducts = createAction(
  '[GA Product Tips] Button clicked',
  props<{ label: string }>()
);

export type ProductTipActions =
  | typeof AccordionOpen
  | typeof TipPageLoad
  | typeof BrowseNewProducts;
